import { MdelloUser } from 'mdello-client-ts/dist/src/types/mdelloAdmin';
import { getDataFromLocalStorage } from 'src/localStorage/getDataFromLocalStorage';
import { LocalStorageKey } from 'src/localStorage/enums/localStorageKey.enum';
import { getClient } from './mdello-instance';

const userRole: string | undefined = getDataFromLocalStorage(LocalStorageKey.USER_ROLE);

export const isCurrentUserRoot: boolean = userRole === 'root';
export const isCurrentUserAdmin: boolean = userRole === 'admin';

export const getRoleFromLocalStorage = (): string | undefined => {
  return getDataFromLocalStorage(LocalStorageKey.USER_ROLE);
};

export const getUserRoleIsUser = (): boolean => {
  return getRoleFromLocalStorage() === 'user';
};

export const getCurrentUser = async (): Promise<MdelloUser> => {
  const user = await getClient()?.self();
  return user!;
};
